<template>
<v-app id="inspire">
  <NaviMenu v-if="$route.meta.requiresAuth" />
  <v-main>
    <router-view />
  </v-main>
  <!-- notification -->
  <v-snackbar v-model="$store.getters.snack.visible" :color="$store.getters.snack.type" top>
    {{ $store.getters.snack.mess }}
  </v-snackbar>
  <!-- lightbox -->
  <v-dialog v-model="$store.getters.preview.visible" max-width="600px">
    <v-img v-if="!!$store.getters.preview.src" :src="$store.getters.preview.src" class="preview">
      <template v-slot:placeholder>
        <v-layout fill-height align-center justify-center ma-0>
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>
  </v-dialog>
  <!-- combo select -->
  <SelectedDialog
    :items="$store.getters.selected.items"
    :show="$store.getters.selected.visible"
    :add="$store.getters.selected.add" />
  <!-- loading -->
  <v-fade-transition>
    <v-container v-if="$store.getters.loading" class="loadmask" fluid fill-height>
      <v-layout align-center justify-center>
        <v-progress-circular :size="50" indeterminate></v-progress-circular>
      </v-layout>
    </v-container>
  </v-fade-transition>
  <Footer />
</v-app>
</template>

<script>
import NaviMenu from '@/components/NaviMenu.vue'
import Footer from '@/components/Footer.vue'
import SelectedDialog from '@/components/SelectedDialog.vue'

export default {
  data() {
    return {
      hoge: true
    }
  },
  props: {

  },
  computed: {},
  components: {
    NaviMenu,
    Footer,
    SelectedDialog,
  }
}
</script>

<style lang='scss'>
body {
  font-family: "Noto Sans JP", Roboto, sans-serif;
}
#inspire {
  font-family: "Noto Sans JP", Roboto, sans-serif;
  background-color: #FFF;
  user-select: none;
  section {
    margin-bottom: 30px;
  }
  h2 {
    font-size: 20px;
    border-left: 10px solid #0277bd;
    padding: 5px 0 5px 10px;
  }
  h3 {
    font-size: 18px;
    margin-bottom: 18px;
    border-bottom: 3px solid #cce4ff;
    padding: 5px 0;
    padding-left: 10px;
    position: relative;
    .ctrl-btn {
      position: absolute;
      right: 10px;
      top: 5px;
      cursor: pointer;
      font-size: 20px;
      color: #326e92;
      &:after {
        content: "\f139";
        font-family: 'Font Awesome 5 Free';
        font-weight: 900;
      }
      &.opened:after {
        content: "\f13a";
      }
    }
  }
  h3:after {
    position: absolute;
    content: "";
    display: block;
    border-bottom: 3px solid #5472cd;
    left: 0;
    bottom: -3px;
    width: 20%;
  }
}
.v-card {
  &.drawer-card {
    position: relative;
    padding-bottom: 70px;
    .v-card__actions {
      position: fixed;
      bottom: 0;
      width: 100%;
      background: #FFF;
      border-top: 1px solid #DDD;
      .v-btn {
        padding-left: 30px;
        padding-right: 30px;
      }
    }
  }
  .v-card__title {
    font-size: 18px;
    .title {
      border-left: 7px solid #578aa9;
      padding-left: 10px;
      font-size: 16px !important;
    }
  }
  .v-card__actions {
    z-index: 2;
  }
}
.v-dialog {
  .dialog-header {
    padding: 10px 20px 10px !important;
  }
  .dialog-header + div {
    padding-top: 20px !important;
  }
  .dialog-header,
  .dialog-footer {
    background-color: #0277bd !important;
    border-color: #0277bd !important;
    color: #FFF;
  }
  .v-subheader {
    padding-left: 0;
    height: auto;
    padding-bottom: 10px;
    font-size: 16px;
    color: #666;
  }
  &:not(.v-dialog--fullscreen) {
    margin: 70px 24px auto 24px;
  }
  &.select-dialog {
    max-height: 60%;
  }
  .preview {
    background: #FFF;
  }
}
.edit-dialog {
  .v-subheader {
    padding-left: 0;
    height: auto;
    padding-bottom: 10px;
    font-size: 14px;
    color: #666;
  }
}
p.label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.6);
  margin-bottom: 10px;
  margin-top: -8px;
}
ul.list-inline {
  list-style: none;
  padding: 0;
  li {
    display: inline-block;
  }
}
ul.list-unstyled {
  list-style: none;
  padding: 0;
  li {
    display: block;
  }
}
.v-input {
  &.required {
    .v-label {
      color: #b71c1c;
      &::after {
        content: " ※"
      }
    }
  }
  &.text-right {
    input {
      text-align: right;
    }
  }
}
.v-date-picker-title__date {
  font-size: 20px !important;
}
.theme--light.v-input--is-disabled {
  input,
  textarea {
    color: #333;
  }
}
.v-data-table {
  .v-row-group__header {
    background-color: #e2f6ff !important;
  }
  tbody {
    tr.disabled {
      td {
        color: #CCC;
      }
    }
    td {
      cursor: pointer;
    }
  }
}
.draggable-table {
  .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: dashed;
  }
}
ul.attention {
  list-style: none;
  padding: 0;
  color: #666;
  font-size: 14px;
  margin: 10px 0;
  &:before {
    content: "【ご注意】";
  }
  li {
    position: relative;
    padding-left: 20px;
    &:before {
      content: "※";
      position: absolute;
      left: 0;
    }
  }
}
.quill-editor {
  .ql-editor {
    font-family: "Noto Sans JP", Roboto, sans-serif;
    h1, h2, h3, h4 {
      margin-bottom: 20px;
    }
    h1 {

    }
    h2 {

    }
    h3 {
      border: none !important;
      background: none !important;
      font-size: 1.17em !important;
      padding: 0 !important;
    }
    p {
      margin-bottom: 15px;
    }
  }
}
.v-chip {
  span {
    margin: 0 auto;
  }
}
.gantt-elastic {
  .gantt-elastic__chart-row-bar {
    &:hover {
      cursor: pointer;
    }
  }
}
.vue-swatches__row {
  line-height: 0;
}
.loadmask {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  background: #FFF;
}
/*----------------------
プリント設定
----------------------*/
@media print {
  #navi_menu,
  footer {
    display: none !important;
  }
  main {
    padding: 0 !important;
  }
  .v-dialog {
    .dialog-header,
    .dialog-footer {
      display: none !important;
    }
  }
  .print-sheet {
    font-size: 12px;
    padding: 0 !important;
    .v-tabs-bar {
      display: none !important;
    }
    th.quantity {
      width: 70px !important;
    }
    th.value,
    th.amount,
    .total > div .value {
      width: 100px !important;
    }
  }
}
@page {
  margin: 5mm;
}
</style>
